/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  GraphQueryMgr,
  UnusedAccessReq
} from '@src/endpoints/services/graphQueryMgr.service'
import type * as Models from './models'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { defaultHandleStatus, paramsWithFilter } from '@src/endpoints/helpers'
import type { State } from '@src/redux/configureStore'
import { parseDetails } from './helpers'

export const initialState = {
  isPending: false as boolean,
  identityDetail: {
    items: [] as Models.UnusedIdentityDetailItem[]
  } as Models.IdentityDetail,
  identityService: {
    items: [] as Models.UnusedIdentityServiceItem[]
  } as Models.UnusedIdentityService,
  identityPrivilege: {
    items: [] as Models.UnusedIdentityPrivilegeItem[]
  } as Models.UnusedIdentityPrivilege,
  rolePrivilege: {
    items: [] as Models.UnusedRoleServiceItem[]
  } as Models.UnusedRolePrivilege,
  roleService: {
    items: [] as Models.UnusedRoleServiceItem[]
  } as Models.UnusedRoleService,
  identityByServiceByRole: {
    items: [] as Models.IdentityByServiceByRoleItem[]
  } as Models.IdentityByServiceByRole,
  identityByPrivilegeByRole: {
    items: [] as Models.IdentityByPrivilegeByRoleItem[]
  } as Models.IdentityByPrivilegeByRole,
  identityWithoutRoleByService: {
    items: [] as Models.IdentityWithoutRoleByServiceItem[]
  } as Models.IdentityWithoutRoleByService,
  identityWithoutRoleByPrivilege: {
    items: [] as Models.IdentityWithoutRoleByPrivilegeItem[]
  } as Models.IdentityWithoutRoleByPrivilege
}

export interface GetDataPayload {
  isPending?: boolean
  identityDetail: Models.IdentityDetail
  identityService: Models.UnusedIdentityService
  identityPrivilege: Models.UnusedIdentityPrivilege
  rolePrivilege: Models.UnusedRolePrivilege
  roleService: Models.UnusedRoleService
  identityByServiceByRole: Models.IdentityByServiceByRole
  identityByPrivilegeByRole: Models.IdentityByPrivilegeByRole
  identityWithoutRoleByService: Models.IdentityWithoutRoleByService
  identityWithoutRoleByPrivilege: Models.IdentityWithoutRoleByPrivilege
}

const unusedAccessDetails = createSlice({
  name: 'unusedAccessDetails',
  initialState,
  reducers: {
    changeState: (
      state,
      action: PayloadAction<Partial<typeof initialState>>
    ) => ({ ...state, ...action.payload }),
    pending: (state, action: PayloadAction<{ isPending?: boolean }>) => {
      state.isPending = action.payload.isPending
    },
    loadedData: (state, action: PayloadAction<GetDataPayload>) => {
      const {
        rolePrivilege = {},
        roleService = {},
        isPending = false,
        identityDetail = {},
        identityPrivilege = {},
        identityService = {},
        identityByPrivilegeByRole = {},
        identityByServiceByRole = {},
        identityWithoutRoleByPrivilege = {},
        identityWithoutRoleByService = {}
      } = action?.payload || ({} as GetDataPayload)
      state.isPending = isPending
      state.rolePrivilege = rolePrivilege
      state.roleService = roleService
      state.identityDetail = identityDetail
      state.identityPrivilege = identityPrivilege
      state.identityService = identityService
      state.identityByPrivilegeByRole = identityByPrivilegeByRole
      state.identityByServiceByRole = identityByServiceByRole
      state.identityWithoutRoleByPrivilege = identityWithoutRoleByPrivilege
      state.identityWithoutRoleByService = identityWithoutRoleByService
    },
    dispose: state => initialState
  }
})

export const getData =
  (params: UnusedAccessReq) => (dispatch: any, getStore: () => State) => {
    const { auth, filter } = getStore()
    dispatch(
      unusedAccessDetails.actions.changeState({
        ...initialState,
        isPending: true
      })
    )
    GraphQueryMgr.UnusedAccess({ params: paramsWithFilter(params, filter) })
      .then(res =>
        defaultHandleStatus(
          res,
          () => {
            dispatch(unusedAccessDetails.actions.pending({ isPending: false }))
          },
          true
        )
      )
      .then(response => {
        const {
          role_service_detail,
          role_privilege_detail,
          identity_detail,
          identity_by_service,
          identity_by_privilege,
          identity_by_service_by_role,
          identity_by_privilege_by_role,
          identity_without_role_by_privilege,
          identity_without_role_by_service
        } = response || {}
        dispatch(
          unusedAccessDetails.actions.loadedData({
            isPending: false,
            identityDetail: parseDetails(identity_detail, auth),
            roleService: parseDetails(role_service_detail, auth),
            rolePrivilege: parseDetails(role_privilege_detail, auth),
            identityService: parseDetails(identity_by_service, auth),
            identityPrivilege: parseDetails(identity_by_privilege, auth),
            identityByServiceByRole: parseDetails(
              identity_by_service_by_role,
              auth
            ),
            identityByPrivilegeByRole: parseDetails(
              identity_by_privilege_by_role,
              auth
            ),
            identityWithoutRoleByPrivilege: parseDetails(
              identity_without_role_by_privilege,
              auth
            ),
            identityWithoutRoleByService: parseDetails(
              identity_without_role_by_service,
              auth
            )
          })
        )
      })
      .catch((res: Response) => {
        dispatch(unusedAccessDetails.actions.pending({ isPending: false }))
      })
  }

export const { reducer, actions, caseReducers } = unusedAccessDetails

export default unusedAccessDetails
